import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { CardComponent } from 'src/app/shared/components/master-detail-layout/card/card.component';
import { GeneralSettingsFormService } from '../../../services/general-settings-form.service';
import { CustomFormGroup } from '@tilby/tilby-ui-lib/components/tilby-magic-form';
import { NoFiscalPrinterForm } from '../../../models/settings-printers.model';

@Component({
  selector: 'app-order-settings',
  standalone: true,
  imports: [
    CommonModule,
    CardComponent,
    MatFormFieldModule, ReactiveFormsModule,
    MatSlideToggleModule,
    TranslateModule
  ],
  templateUrl: './order-settings.component.html',
  styleUrl: './order-settings.component.scss'
})
export class OrderSettingsComponent {
  
  protected readonly generalSettingsformService = inject(GeneralSettingsFormService);

  protected noFiscalGroupForm!: CustomFormGroup<NoFiscalPrinterForm>;

  ngOnInit() {
    this.noFiscalGroupForm = this.generalSettingsformService.noFiscalGroup;
  }
}
